import type { SelectOption } from '@/shared/ui';
import { supportTicketTypeValues } from '@support/entities/support-ticket';
import { Text } from '@/shared/ui';
import css from './create-support-ticket-modal.module.scss';

const humanize = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1).replace(/_/g, ' ');

export const TYPE_OPTIONS: SelectOption[] = supportTicketTypeValues.map(
  (v) => ({ value: v, label: humanize(v) })
);

export const Required = () => (
  <Text aria-hidden as="span" className={css.req}>
    *
  </Text>
);
